import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
import { getImagesByQuery } from './js/pixabay-api';
import {
    createGallery,
    clearGallery,
    showLoader,
    hideLoader,
} from './js/render-functions';

const formEl = document.querySelector('.form');

formEl.addEventListener('submit', onFormSubmit);

function onFormSubmit(event) {
    event.preventDefault();

    const searchQuery = event.target.elements['search-text'].value.trim();

    if (searchQuery === '') {
        iziToast.error({
            message: 'Please enter a search query!',
            position: 'topRight',
        });
        return;
    }

    clearGallery();
    showLoader();

    getImagesByQuery(searchQuery).then(data => {
        if (data.hits.length === 0) {
            iziToast.error({
                message: 'Sorry, there are no images matching your search query. Please try again!',
                position: 'topRight',
            });
            return
        }

        createGallery(data.hits);
    })
        .catch(error => {
            iziToast.error({
                message: 'Something went wrong. Try again later.',
                position: 'topRight',
            });
        })
        .finally(() => {
            hideLoader();
        });
}
